import { IAxiosResponseData } from '@/store';
import { axios } from '@/nmb/request';

const api = `api/Mysoft.Calendar.Common.AppServices.CalendarCommonAppService/`;

// 删除
export const deleteEvent = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}DeleteEvent`, params);
// 查询日历明细
export const queryEvent = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}QueryEvent`, params);
// 查询参与人列表
export const searchEventUser = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserOption`, params);
// 新增
export const addEvent = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}AddOrUpdateEvent`, params);
// 商机
export const getBusinessOpportunity = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetBusinessOpportunity`, params);
// 项目名称
export const getProjInfoWithValid = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetProjInfoWithValid`, params);
// 项目任务
export const getProjectTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetProjectTask`, params);
// 获取会议室
export const getMeetingRoom = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetMeetingRoom`, params);
// 获取工时
export const getRemainingWorkTime = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetRemainingWorkTime`, params);
// 获取任务项
export const getTaskItemOptions = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetTaskItemOptions`, params);
// 获取单位
export const getBusinessUnitList = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetAllBusinessUnitList`, params);
// 获取单位下的成员
export const getDepartmentUsers = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetDepartmentUsers`, params);
// 查询邮件用户列表
export const searchEmailUser = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}GetUserEmailOption`, params);
